// new services (after refactoring)
export * from './web.service';
export * from './env.service';
export * from './notification.service';
export * from './data.service';
// old services (without refactoring)
export * from './common-routing-service';
export * from './commonDataSharedService';
export * from './resolver.service';
export * from './route-data.service';
export * from './common-authentication.service';
export * from './common-request-response.service';
export * from './form-validation.service';
export * from './logged.service';
export * from './partner-detail.service';
export * from './common.service';
export * from './menu.service';
export * from './class-base.service';
export * from './college-detail.service';
export * from './common-chart.service';
export * from './plan-progress.service';
export * from './excel.service';
export * from './student-profile-button.service';
export * from './pager.service';
